module.exports = __webpack_public_path__ + "static/media/img2.312a02f0.png";